import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetCountyListPagingAndFilterRequest } from '../models/request/county/GetCountyListPagingAndFilterRequest';

export class CountyService {
    static async getCountyListPagingAndFilter(inputObj: GetCountyListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetCountyListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/County/GetCountyListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportCountyList(inputObj: GetCountyListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportCountyList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/County/exportCountyList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCountyList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getCountyList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/County/getCountyList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteCounty(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteCounty', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/County/deleteCounty', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getCountyById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getCountyById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/County/getCountyById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}